var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: _vm.classes,
      on: {
        click: function ($event) {
          return _vm.$emit("click", _vm.tabBarItem)
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "tab-bar-item__icon" },
        [_c(_vm.iconComponent, { tag: "component" })],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "tab-bar-item__label" }, [
        _vm._v("\n    " + _vm._s(_vm.tabBarItem.label) + "\n  "),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }